import type { INpdbConfiguration } from '$shared/interfaces/api/INpdbConfiguration';
import BaseModel from './BaseModel';

export class NpdbConfiguration extends BaseModel<INpdbConfiguration> {
  public get entityDbId(): string {
    return this.response?.entityDbId;
  }

  public get entityName(): string {
    return this.response?.entityName;
  }

  public get enrollmentPatchingEnabled(): boolean {
    return !!this.response?.enrollmentPatchingEnabled;
  }

  public get userId(): string {
    return this.response?.userId || '';
  }

  public get password(): string {
    return this.response?.password || '';
  }

  public get useVerifiableAgentCreds(): boolean {
    return !!this.response?.useVerifiableAgentCreds;
  }

  public get autoReEnrollEnabled(): boolean {
    return !!this.response?.autoReEnrollEnabled;
  }

  public get useEntityMode(): boolean {
    return !!this.response?.useEntityMode;
  }

  static from(setting: Record<string, INpdbConfiguration>): Record<string, NpdbConfiguration> {
    return Object.fromEntries(
      Object.entries(setting).map(([segmentId, config]: [string, INpdbConfiguration]) => [
        segmentId,
        new NpdbConfiguration(config)
      ])
    );
  }
}
